export default __webpack_public_path__ + "static/media/flag-draft.27a6f1b8.svg";